// extracted by mini-css-extract-plugin
export default {"searchIcon":"styles_searchIcon__7qZAa","searchInput":"styles_searchInput__u7Z3l","container_hidden":"styles_container_hidden__mQRGS","container":"styles_container__lGFtI"};